import {EtapeScenario} from "./EtapeScenario";
import {BaseObject} from "./BaseObject";
import {ScenarioPreprogramme} from "./ScenarioPreprogramme";
import {PlanGestionMobilite} from "./PlanGestionMobilite";
import {EvenementSpontane} from "./EvenementSpontane";
import {Equipement} from "./Equipment";
import {AssociationSegment} from "./AssociationSegment";

export class BaseObjectFactory {
  public static create(className: string, props: any): BaseObject {
    switch (className) {
      case 'EtapeScenario':
        return new EtapeScenario(props);
      case 'ScenarioPreprogramme':
        return new ScenarioPreprogramme(props);
      case 'PlanGestionMobilite':
        return new PlanGestionMobilite(props);
      case 'EvenementSpontane':
        return new EvenementSpontane(props);
      case 'Equipment':
        return new Equipement(props);
      case 'AssociationSegment':
        return new AssociationSegment(props);
    }

    return new BaseObject({id: -1});
  }
}

